import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProductPreviewRow } from '../model/types';
import ProductsTransferTableBody from './ProductsTransferTableBody';

interface ProductsTransferTableProps {
    rows: ProductPreviewRow[];
    mode?: 'preview' | 'result';
    onToggle?: (key: string) => void;
}

const ProductsTransferTable = ({
    rows,
    mode = 'preview',
    onToggle,
}: ProductsTransferTableProps) => {
    const { t } = useTranslation(['Objects']);
    const ns = 'documents.proposal2Warehouse';

    return (
        <div className="proposal2warehouse-table-wrap px-3 mb-3">
            <h6 className="text-muted mb-2">
                {mode === 'result'
                    ? t(`${ns}.resultTitle`)
                    : t(`${ns}.productsTitle`)}
            </h6>
            <Table size="sm" className="Proposal2WarehouseTable table-hover mb-0 align-middle">
                <thead>
                    <tr className="bg-light">
                        {mode === 'preview' ? <td className="head-check" /> : null}
                        <td className="head-name">{t(`${ns}.colProduct`)}</td>
                        <td className="head-article">{t(`${ns}.colArticle`)}</td>
                        <td className="head-warehouse">{t(`${ns}.colWarehouse`)}</td>
                        <td className="head-qty text-end">{t(`${ns}.colCount`)}</td>
                        {mode === 'result' ? (
                            <td className="head-status">{t(`${ns}.colStatus`)}</td>
                        ) : null}
                    </tr>
                </thead>
                <ProductsTransferTableBody
                    rows={rows}
                    mode={mode}
                    emptyLabel={t(`${ns}.emptyProducts`)}
                    colProduct={t(`${ns}.colProduct`)}
                    colArticle={t(`${ns}.colArticle`)}
                    colWarehouse={t(`${ns}.colWarehouse`)}
                    colQty={t(`${ns}.colCount`)}
                    statusOk={t(`${ns}.statusOk`)}
                    statusFail={t(`${ns}.statusFail`)}
                    statusPartial={t(`${ns}.statusPartial`)}
                    onToggle={onToggle}
                />
            </Table>
        </div>
    );
};

export default ProductsTransferTable;
